(function () {
  'use strict';

  function closestFrom(target, selector) {
    while (target && target !== document) {
      if (target.nodeType === 1 && target.matches && target.matches(selector)) return target;
      target = target.parentElement;
    }
    return null;
  }

  function galleryItems(gallery) {
    return Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
  }

  function galleryFrames(gallery) {
    return Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-frame]'));
  }

  function renderGallery(gallery, index, direction) {
    var frames = galleryFrames(gallery);
    var thumbs = galleryItems(gallery);
    var count = gallery.querySelector('[data-gallery-count]');
    if (!frames.length || !thumbs.length) return;

    index = ((index % frames.length) + frames.length) % frames.length;
    var current = parseInt(gallery.getAttribute('data-gallery-index') || '0', 10);
    if (isNaN(current)) current = 0;
    if (index === current && frames[index].classList.contains('is-active')) return;

    gallery.setAttribute('data-gallery-index', String(index));
    gallery.setAttribute('data-gallery-direction', direction || (index > current ? 'next' : 'prev'));

    frames.forEach(function (frame, i) {
      frame.classList.toggle('is-active', i === index);
      frame.classList.remove('is-entering', 'is-leaving');
    });

    thumbs.forEach(function (item, i) {
      var active = i === index;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-current', active ? 'true' : 'false');
    });

    var activeFrame = frames[index];
    activeFrame.classList.add('is-entering');
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { activeFrame.classList.remove('is-entering'); });
    });

    if (count) count.textContent = (index + 1) + ' / ' + frames.length;

    try {
      thumbs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    } catch (e) {}
  }

  function getGallery(target) { return closestFrom(target, '[data-product-gallery]'); }

  document.addEventListener('click', function (event) {
    var next = closestFrom(event.target, '[data-gallery-next]');
    var prev = closestFrom(event.target, '[data-gallery-prev]');
    var thumb = closestFrom(event.target, '[data-gallery-thumb]');
    var control = next || prev || thumb;
    if (!control) return;
    var gallery = getGallery(control);
    if (!gallery) return;
    event.preventDefault();
    var thumbs = galleryItems(gallery);
    if (!thumbs.length) return;
    var current = parseInt(gallery.getAttribute('data-gallery-index') || '0', 10);
    if (isNaN(current)) current = 0;
    if (thumb) renderGallery(gallery, thumbs.indexOf(thumb), thumbs.indexOf(thumb) > current ? 'next' : 'prev');
    else if (next) renderGallery(gallery, current + 1, 'next');
    else renderGallery(gallery, current - 1, 'prev');
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    var gallery = getGallery(event.target);
    if (!gallery) return;
    var current = parseInt(gallery.getAttribute('data-gallery-index') || '0', 10);
    if (isNaN(current)) current = 0;
    renderGallery(gallery, current + (event.key === 'ArrowRight' ? 1 : -1), event.key === 'ArrowRight' ? 'next' : 'prev');
  });

  var touchStart = null;
  document.addEventListener('touchstart', function (event) {
    var gallery = getGallery(event.target);
    if (!gallery || event.touches.length !== 1) return;
    touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY, gallery: gallery };
  }, { passive: true });

  document.addEventListener('touchend', function (event) {
    if (!touchStart || !event.changedTouches.length) return;
    var state = touchStart;
    touchStart = null;
    if (!state.gallery.contains(event.target)) return;
    var dx = event.changedTouches[0].clientX - state.x;
    var dy = event.changedTouches[0].clientY - state.y;
    if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
    var current = parseInt(state.gallery.getAttribute('data-gallery-index') || '0', 10);
    if (isNaN(current)) current = 0;
    renderGallery(state.gallery, current + (dx < 0 ? 1 : -1), dx < 0 ? 'next' : 'prev');
  }, { passive: true });

  function initGalleries(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-product-gallery]'), function (gallery) {
      var frames = galleryFrames(gallery);
      var thumbs = galleryItems(gallery);
      if (!frames.length) return;
      gallery.setAttribute('data-gallery-index', '0');
      frames.forEach(function (frame, i) { frame.classList.toggle('is-active', i === 0); });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === 0);
        thumb.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      });
    });
  }

  function updateVariantUI(root) {
    var scope = root || document;
    var select = scope.querySelector('[data-variant-select]');
    var priceEl = scope.querySelector('#ProductPrice');
    var addButton = scope.querySelector('#ProductAdd');
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    if (!opt) return;
    var price = opt.getAttribute('data-price');
    var rawAvailable = (opt.getAttribute('data-available') || '').toLowerCase();
    var inventory = parseInt(opt.getAttribute('data-inventory') || '0', 10);
    var policy = (opt.getAttribute('data-policy') || '').toLowerCase();
    var available = rawAvailable === 'true' || inventory > 0 || policy === 'continue';
    if (price && priceEl) priceEl.textContent = price;
    if (addButton) {
      addButton.disabled = !available;
      addButton.textContent = available ? 'Add to cart' : 'Sold out';
    }
  }

  function updateCartQuantity(input, delta) {
    var value = Math.max(0, parseInt(input.value || '0', 10) + delta);
    input.value = value;
    var form = input.form;
    if (!form) return;
    var inputs = form.querySelectorAll('[data-cart-quantity]');
    var updates = [];
    Array.prototype.forEach.call(inputs, function (el) { updates.push(parseInt(el.value || '0', 10)); });
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { if (!r.ok) throw new Error('Cart update failed'); return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () { form.submit(); });
  }

  document.addEventListener('click', function (event) {
    var minus = closestFrom(event.target, '[data-qty-minus]');
    var plus = closestFrom(event.target, '[data-qty-plus]');
    if (!minus && !plus) return;
    event.preventDefault();
    var wrapper = (minus || plus).parentElement;
    var input = wrapper && wrapper.querySelector('[data-cart-quantity]');
    if (input) updateCartQuantity(input, plus ? 1 : -1);
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches && event.target.matches('[data-cart-quantity]')) {
      var input = event.target;
      var value = Math.max(0, parseInt(input.value || '0', 10));
      input.value = value;
      if (input.form) input.form.requestSubmit();
    }
    if (event.target.matches && event.target.matches('[data-variant-select]')) updateVariantUI(event.target.closest('section') || document);
  });

  function init(root) { initGalleries(root); updateVariantUI(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target || document); });
  document.addEventListener('shopify:section:reorder', function () { init(document); });
})();
